<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="AreaAdd"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start">
                    {{ $t("areaAdd") }}
                  </h6>
                  <button
                    class="btn btn-default btn-sm float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>
                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->

                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "
                    ></div>

                    <div class="card">
                      <div class="card-body">
                        <h5 class="General"></h5>
                        <hr />
                        <div class="row mb-3">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("areaCodeTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-3">
                            <input
                              type="text"
                              class="form-control"
                              id="area_code"
                              :placeholder="$t('areaCodeTxt')"
                              v-model="forms.area_code"
                              required
                            />
                            <div v-if="errors.area_code">
                              <div
                                v-for="error in errors.area_code"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-1">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("areaNameTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-4">
                            <input
                              type="text"
                              class="form-control"
                              id="area_name"
                              :placeholder="$t('areaNameTxt')"
                              v-model="forms.area_name"
                              required
                            />
                            <div v-if="errors.area_name">
                              <div
                                v-for="error in errors.area_name"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                        

                        <div class="row mb-3">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("statusTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-3">
                            <!-- <select
                              class="form-control"
                              name="company_id"
                              id="company_id"
                              v-model="forms.company_id"
                            >
                              <option
                                v-for="(a, index) of fetchCompany"
                                :value="a.company_id"
                                :key="index"
                              >
                                {{ a.code }} | {{ a.name }}
                              </option>
                            </select> -->

                            <v-select
                            
                              :options="statustype"
                              v-model="forms.status"
                              label="code"
                              return-object
                              @search="asyncSearchCompany"
                            ></v-select>

                            <v-select
                              v-if="companyCode != 'LINC'"
                              :options="fetchCompanyNotLinc"
                              v-model="company"
                              label="code"
                              return-object
                              @search="asyncSearchCompanyNotLinc"
                            ></v-select>

                            <div v-if="errors.company_id">
                              <div
                                v-for="error in errors.company_id"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                         
                        </div>
                      </div>
                    </div>

                    <br />

                  

                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import myMixinAddress from '@/middleware/mixinAddress.js';


export default {
  name: "LocationAdd",
  mixins: [myMixinAddress],
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      statustype :["Active","Non Active"],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      fetchCompany: [],
      fetchCompanyNotLinc: [],
      fetchRegion: [],
      fetchSystemCode: [],
      errors: [],
      permision_role: [],
      userData: "",
      companyCode: "",
      // company: [],
      // region: [],
      // postalCode:[],
      // countryCode:[],
      // provinceCode:[],
      // cityCode:[],
      // districtCode:[],
      // subDistrictCode:[],

      // fetchPostalCode: [],
      // fetchCountryCode: [],
      // featchProvinceCode: [],
      // featchCityCode: [],
      // featchDistrictCode: [],
      // featchSubDistrictCode: [],

      // postal_code: [],
      // country: [],
      // province: [],
      // city: [],
      // district: [],
      // sub_district: [],
      // city_type: "",
      // type:[],

      // featchCompany: [],

      forms: {  },
    };
  },
  watch: {},
  methods: {
    resetForm() {
      this.forms.area_code = "";
      this.forms.area_name = "";
     // this.forms.status = "";
      this.status = [];

     
    },

    backForm() {
      window.location.href = "/area";
    },

    // loadCompany() {
    //   const baseURI = this.$settings.endPoint + "company?limit=10";

    //   return this.$http.get(baseURI).then((response) => {
    //     this.fetchCompany = response.data.datas.data;
    //   });
    // },

    loadCompanyNotLinc() {
      const baseURI =
        this.$settings.endPoint + `company/select`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompanyNotLinc = response.data.datas.data;
      });
    },

    asyncSearchCompany(ev) {
      const baseURI = this.$settings.endPoint + "company?code=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },

    asyncSearchCompanyNotLinc(ev) {
      const baseURI =
        this.$settings.endPoint +
        "company/select&code="+ev
        this.companyCode;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompanyNotLinc = response.data.datas.data;
      });
    },

    asyncSearchRegion(ev) {
      const baseURI = this.$settings.endPoint + "region?region_code=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchRegion = response.data.datas.data;
      });
    },


    loadSystemCode() {
      const baseURI = this.$settings.endPoint + "system-code/select?system_code=LOCATION_TYPE";
      return this.$http.get(baseURI).then((response) => {
        this.fetchSystemCode = response.data.datas.data;
      });
    },

    asyncSearchSystemCode(ev) {
      const baseURI = this.$settings.endPoint + "system-code?system_code=LOCATION_TYPE&description=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchRegion = response.data.datas.data;
      });
    },

    loadRegion() {
      const baseURI = this.$settings.endPoint + "region?limit=10";

      return this.$http.get(baseURI).then((response) => {
        this.fetchRegion = response.data.datas.data;
      });
    },

    submitData() {
      this.fade(true);
    

     

      const baseURI = this.$settings.endPoint + "area/create";
      this.$http
        .post(baseURI, this.forms)
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            //this.resetForm();
            this.errors = [];
            //console.log(response.data.datas.user_id);
            var params = this.$onRandom(response.data.datas.area_id);
            window.location.href =
              "/area/detail/" + params + "?status=200&msg=Successfully";
            // this.success('Berhasil');
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.loading();
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
          //this.resetForm();
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.companyCode = this.detailUser.company_detail.code;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "AreaController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_create) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    // this.loadRegion();
    // this.loadCompany();
    // this.loadCountryCode();
    // this.loadCompanyNotLinc();
    // this.loadSystemCode();
    // this.loadPostalCode();
    // this.loadCountryCode();
    
  },
};
</script>
<style scoped>
</style>